var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CSS3_logo 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9369 90.0037L5.91251 0H94.0875L86.0545 89.9895L49.9461 100L13.9369 90.0037Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.1773 84.2594L86.0422 7.35901H50V92.3485L79.1773 84.2594Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.3086 40.7402L25.2979 51.7787H50V40.7402H24.3086ZM23.324 29.4365H50V18.3978H22.3205L23.324 29.4365ZM50 69.4086L49.9516 69.4215L37.6578 66.1019L36.8721 57.298H25.7908L27.3375 74.6302L49.9492 80.9076L50 80.8933V69.4086Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.9619 40.7402V51.7787H63.5547L62.2734 66.0949L49.9619 69.4178V80.9021L72.5916 74.6302L72.7576 72.7652L75.3514 43.7043L75.6209 40.7402L77.6137 18.3978H49.9619V29.4365H65.5164L64.5117 40.7402H49.9619Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechCss);
export default __webpack_public_path__ + "static/media/Tech-CSS.544da293137a19955846a09360ab9a84.svg";
export { ForwardRef as ReactComponent };